import { validationConstants, validations } from "@/utils/validationUtils";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import LabelWithTooltip from "../../../../common/components/form/labels/LabelWithTooltip";
import { AgentDirectoratesSelect } from "../../../enumerations/components/form/AgentDirectoratesSelect";
import { AgentSelect } from "../../../enumerations/components/form/AgentSelect";

type Props = {
  children?: React.ReactNode;
};

export const AgentCommonFilterFields = ({ children }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      {children}

      <Form.Item
        name="keyword"
        label={t("common.searchKeyword")}
        rules={[
          validations.size(
            validationConstants.SEARCH_KEYWORD_MIN_LENGTH,
            validationConstants.SEARCH_KEYWORD_MAX_LENGTH,
          ),
        ]}
      >
        <Input allowClear placeholder={t("agent.helpers.searchHint")} />
      </Form.Item>

      <Form.Item
        name="rootAgentId"
        label={<LabelWithTooltip tooltip={t("agent.helpers.rootAgentHint")} label={t("agent.filter.rootAgentId")} />}
      >
        <AgentSelect allowClear />
      </Form.Item>

      <Form.Item name="directorateIds" label={t("agent.filter.directorates")} rules={[validations.none]}>
        <AgentDirectoratesSelect isMultiple allowClear />
      </Form.Item>
    </>
  );
};
